<p>stockgroup-report works!</p>
